import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { baseAuthEffects, baseAuthReducer } from '../../_store';

@NgModule({
  imports: [
    StoreModule.forFeature('auth', baseAuthReducer.baseAuthReducer),
    EffectsModule.forFeature([baseAuthEffects.BaseAuthEffects]),
  ],
})
export class BaseAuthStoreModule {}
